import { __extends } from "tslib";
import { InternalRadioButton } from './internal-radio-button/internal-radio-button';
import { namespacedClassnames } from '../../common';
import * as React from 'react';
import * as propTypes from 'prop-types';
var RadioButton = /** @class */ (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioButton.prototype.render = function () {
        var props = this.props;
        var _a = this.context.radioGroup, selectedValue = _a.selectedValue, onChange = _a.onChange;
        var checked = props.value === selectedValue;
        var disabled = props.disabled;
        var onSelect = onChange.bind(null, props.value);
        var classNames = namespacedClassnames('radio-button', { checked: checked, disabled: disabled }, props.className);
        return (React.createElement("label", { className: classNames, "data-value": props.value },
            React.createElement(InternalRadioButton, { checked: checked, disabled: disabled, onSelect: onSelect, tooltipButton: props.tooltipButton }, props.children)));
    };
    RadioButton.contextTypes = {
        radioGroup: propTypes.object
    };
    return RadioButton;
}(React.Component));
export { RadioButton };
// tslint:disable-next-line:max-classes-per-file
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioGroup.prototype.getChildContext = function () {
        var _a = this.props, selectedValue = _a.selectedValue, onChange = _a.onChange;
        return { radioGroup: { selectedValue: selectedValue, onChange: onChange } };
    };
    RadioGroup.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames('radio-group', props.className);
        return React.createElement("div", { className: classNames }, props.children);
    };
    RadioGroup.childContextTypes = {
        radioGroup: propTypes.object
    };
    return RadioGroup;
}(React.Component));
export { RadioGroup };
//# sourceMappingURL=radio-group.js.map